document.addEventListener("DOMContentLoaded", function () {
  const mq = window.matchMedia("(max-width: 799px)");

  function initFooterAccordion() {
    if (!mq.matches) return;

    const blocks = document.querySelectorAll(
      ".footer__blocks-wrapper .footer-block"
    );

    blocks.forEach((block) => {
      const heading = block.querySelector(".footer-block__heading button");
      const list = block.querySelector(".footer-block__details-content");

      if (!heading || !list) return;

      // Accessibility
      // heading.setAttribute("role", "button");
      // heading.setAttribute("tabindex", "0");
      heading.setAttribute("aria-expanded", "false");

      heading.addEventListener("click", toggle);
      heading.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggle();
        }
      });

      function toggle() {
        const isOpen = block.classList.contains("is-open");

        // close others
        blocks.forEach((b) => {
          b.classList.remove("is-open");
          const h = b.querySelector(".footer-block__heading button");
          h && h.setAttribute("aria-expanded", "false");
        });

        // toggle current
        if (!isOpen) {
          block.classList.add("is-open");
          heading.setAttribute("aria-expanded", "true");
        }
      }
    });
  }

  initFooterAccordion();
});

document.addEventListener('DOMContentLoaded', () => {
  const mq = window.matchMedia('(min-width: 990px)');

  function updateAria() {
    const headings = document.querySelectorAll('.footer-block__heading');
    const panels = document.querySelectorAll('.footer-block__details-content');

    headings.forEach((heading) => {
      const panelId = heading.getAttribute('aria-controls');

      if (mq.matches) {
        // Desktop → remove aria-controls + aria-labelledby pairing
        heading.removeAttribute('aria-controls');
      } else {
        // Mobile → restore if needed (optional, adjust if SSR already provides)
        if (!heading.hasAttribute('aria-controls') && panelId) {
          heading.setAttribute('aria-controls', panelId);
        }
      }
    });

    panels.forEach((panel) => {
      if (mq.matches) {
        panel.removeAttribute('aria-labelledby');
      } else {
        const id = panel.getAttribute('id');
        if (!panel.hasAttribute('aria-labelledby') && id) {
          panel.setAttribute('aria-labelledby', id.replace('panel', 'heading'));
        }
      }
    });
  }

  mq.addEventListener('change', updateAria);
  updateAria();
});



// for mobile expand menu
document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.site-mega-menu-simple-links-item');

  function closeAll(returnFocus = false) {
    items.forEach(item => {
      const title = item.querySelector('a.h3');
      const dropdown = item.querySelector('.sub-drop-down');
      const svg = title?.querySelector('svg');

      if (!title || !dropdown) return;

      dropdown.classList.remove('open');
      dropdown.setAttribute('hidden', '');

      title.setAttribute('aria-expanded', 'false');

      if (svg) {
        svg.classList.remove('rotated');
        svg.setAttribute('aria-hidden', 'true');
      }

      if (returnFocus) title.focus();
    });
  }

  items.forEach((item, index) => {
    const title = item.querySelector('a.h3');
    const dropdown = item.querySelector('.sub-drop-down');
    const svg = title?.querySelector('svg');

    if (!title || !dropdown) return;

    // ADA setup
    const dropdownId = dropdown.id || `submenu-${index}`;

    dropdown.id = dropdownId;

    title.setAttribute('role', 'button');
    title.setAttribute('aria-expanded', 'false');
    title.setAttribute('aria-controls', dropdownId);

    dropdown.setAttribute('hidden', '');

    if (svg) {
      svg.setAttribute('aria-hidden', 'true');
    }

    function toggleMenu(ev) {
      ev.preventDefault();
      ev.stopPropagation();

      const isOpen = title.getAttribute('aria-expanded') === 'true';

      closeAll();

      if (!isOpen) {
        dropdown.classList.add('open');
        dropdown.removeAttribute('hidden');

        title.setAttribute('aria-expanded', 'true');

        if (svg) svg.classList.add('rotated');
      }
    }

    // Mouse
    title.addEventListener('click', toggleMenu);

    // Keyboard
    title.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        toggleMenu(e);
      }

      if (e.key === 'Escape') {
        closeAll(true);
      }
    });
  });

  // Outside click
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.site-mega-menu-simple-links-item')) {
      closeAll();
    }
  });

  // Global Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeAll(true);
    }
  });
});

// focus trap for mobile menu
document.addEventListener('DOMContentLoaded', () => {

  const drawerMenus = document.querySelectorAll(
    '.menu-drawer__navigation details'
  );
  
  drawerMenus.forEach((detail) => {
    const summary = detail.querySelector('summary');
    const submenu = detail.querySelector('.menu-drawer__submenu');
    const closeBtn = detail.querySelector('.menu-drawer__close-button');

    if (!summary || !submenu) return;

    summary.addEventListener('click', () => {

      setTimeout(() => {

        const opened = detail.hasAttribute('open');
        removeAttribute('aria-expanded');
        summary.setAttribute(
          'aria-expanded',
          opened
        );

        if (!opened) return;

        const focusables = submenu.querySelectorAll(`
          a,
          button,
          input,
          select,
          textarea,
          [tabindex]:not([tabindex="-1"])
        `);

        if (!focusables.length) return;

        focusables[0].focus();

        submenu.addEventListener('keydown', trapFocus);

        function trapFocus(e) {

          if (e.key !== 'Tab') return;

          const first = focusables[0];
          const last =
            focusables[focusables.length - 1];

          if (e.shiftKey) {

            if (
              document.activeElement === first
            ) {
              e.preventDefault();
              last.focus();
            }

          } else {

            if (
              document.activeElement === last
            ) {
              e.preventDefault();
              first.focus();
            }

          }

          if (e.key === 'Escape') {
            closeSubmenu();
          }
        }

      }, 50);

    });

    function closeSubmenu() {

      detail.removeAttribute('open');

      summary.setAttribute(
        'aria-expanded',
        'false'
      );

      summary.focus();
    }

    closeBtn?.addEventListener(
      'click',
      closeSubmenu
    );

  });

});

// focus on sub menu
let activeFocusTrap = null;

function getFocusable(container) {
  return Array.from(
    container.querySelectorAll(
      'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'
    )
  ).filter(el => el.offsetParent !== null); // ONLY visible elements
}

function trapFocus(container) {
  const focusables = getFocusable(container);
  if (!focusables.length) return;

  const first = focusables[0];
  const last = focusables[focusables.length - 1];

  // delay = IMPORTANT (wait for render)
  setTimeout(() => first.focus(), 50);

  function handleKey(e) {
    if (e.key !== 'Tab') return;

    const current = document.activeElement;

    if (e.shiftKey) {
      if (current === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (current === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  container.addEventListener('keydown', handleKey);

  return () => container.removeEventListener('keydown', handleKey);
}




// for mobile menu alphabet scroll
document.addEventListener('click', function(e) {
  const link = e.target.closest('.alpha-link');
  if (!link) return;

  e.preventDefault();

  const letter = link.dataset.letter;
  console.log('[DEBUG] Clicked letter:', letter);

  const container = document.querySelector('.alpha-menu');
  if (!container) {
    console.warn('[DEBUG] .alpha-menu container not found');
    return;
  }
  console.log('[DEBUG] Scroll container found:', container);

  const target = container.querySelector(`.alpha-group[data-group="${letter}"]`);
  if (!target) {
    console.warn('[DEBUG] No alpha-group found for letter:', letter);
    return;
  }
  console.log('[DEBUG] Target element found:', target);

  // Calculate offsetTop relative to container
  let scrollTop = 0;
  let node = target;
  while (node && node !== container) {
    scrollTop += node.offsetTop;
    node = node.offsetParent;
  }
  console.log('[DEBUG] Calculated scrollTop:', scrollTop);

  container.scroll({
    top: scrollTop,
    behavior: 'smooth'
  });

  console.log('[DEBUG] Scroll executed');
});

// search bx js
(function () {
  function getSearchContext(target) {
    const form = target.closest(".search-modal__form");
    if (!form) return null;
    return {
      form,
      input: form.querySelector('input[type="search"]'),
      box: form.querySelector(".predictive-search-box"),
      rec: form.querySelector(".predictive-search__rec-wrapper")
    };
  }
  function closeSearch(ctx) {
    if (!ctx || !ctx.box || !ctx.input) return;
    ctx.box.classList.remove("is-open");
    // ctx.input.value = "";
    ctx.input.setAttribute("aria-expanded", "false");
    if (ctx.rec) ctx.rec.classList.remove("is-hidden");
    // reset Dawn predictive-search
    ctx.input.dispatchEvent(new Event("input", { bubbles: true }));
    ctx.input.blur();
  }

  /* GET FOCUSABLE ELEMENTS IN SEARCH RESULTS */
  function getFocusableElements(ctx) {
    if (!ctx || !ctx.box) return [];
    // Get all links and buttons that are visible
    const focusable = Array.from(
      ctx.box.querySelectorAll("a, button")
    );
    // Filter to only visible elements (not hidden by .is-hidden or display:none)
    return focusable.filter(el => {
      const isInHiddenContainer = el.closest(".is-hidden");
      const isVisible = el.offsetParent !== null;
      return isVisible && !isInHiddenContainer;
    });
  }

  /* OPEN on input click / focus */
  document.addEventListener("click", function (e) {
    const input = e.target.closest("#simple-search-header");
    if (!input) return;
    const ctx = getSearchContext(input);
    if (!ctx || !ctx.box) return;
    ctx.box.classList.add("is-open");
    input.setAttribute("aria-expanded", "true");
  });
  document.addEventListener("focusin", function (e) {
    const input = e.target.closest("#simple-search-header");
    if (!input) return;
    const ctx = getSearchContext(input);
    if (!ctx || !ctx.box) return;
    ctx.box.classList.add("is-open");
    input.setAttribute("aria-expanded", "true");
  });

  /* HANDLE RECOMMENDATION VISIBILITY */
  function updateRecommendations(ctx) {
    if (!ctx || !ctx.rec || !ctx.input) return;
    // Hide recommendations ONLY if user typed something
    ctx.rec.classList.toggle("is-hidden", ctx.input.value.trim().length > 0);
  }

  /* KEYUP → hide / show recommended */
  document.addEventListener("keyup", function (e) {
    const input = e.target.closest(".search-modal__form input[type='search']");
    if (!input) return;
    const ctx = getSearchContext(input);
    updateRecommendations(ctx);
  });

  /* INITIAL CHECK on page load */
  document.addEventListener("DOMContentLoaded", function () {
    const input = document.querySelector(".search-modal__form input[type='search']");
    if (!input) return;
    const ctx = getSearchContext(input);
    updateRecommendations(ctx);
  });

  /* CLOSE button */
  document.addEventListener("click", function (e) {
    const closeBtn = e.target.closest("#close_psb");
    if (!closeBtn) return;
    const ctx = getSearchContext(closeBtn);
    closeSearch(ctx);
  });

  /* ESC key */
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    const openBox = document.querySelector(".predictive-search-box.is-open");
    if (!openBox) return;
    const ctx = getSearchContext(openBox);
    closeSearch(ctx);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Tab") return;
    const openBox = document.querySelector(".predictive-search-box.is-open");
    if (!openBox) return;
    const ctx = getSearchContext(openBox);
    if (!ctx || !ctx.input) return;

    const focusableElements = getFocusableElements(ctx);
    if (focusableElements.length === 0) return;

    const activeElement = document.activeElement;
    const currentIndex = focusableElements.indexOf(activeElement);
    const lastIndex = focusableElements.length - 1;

    // TAB: cycle forward through focusable elements
    if (!e.shiftKey) {
      // If focus is on input, move to first result
      if (activeElement === ctx.input) {
        e.preventDefault();
        focusableElements[0].focus();
      }
      // If focus is on last result, move back to input
      else if (currentIndex === lastIndex) {
        e.preventDefault();
        ctx.input.focus();
      }
      // Otherwise let natural tab flow work through results
    }

    // SHIFT+TAB: cycle backward through focusable elements
    if (e.shiftKey) {
      // If focus is on input, move to last result
      if (activeElement === ctx.input) {
        e.preventDefault();
        focusableElements[lastIndex].focus();
      }
      // If focus is on first result, move back to input
      else if (currentIndex === 0) {
        e.preventDefault();
        ctx.input.focus();
      }
      // Otherwise let natural shift+tab flow work through results
    }
  });

  /* CLOSE when clicking outside */
  document.addEventListener("click", function (e) {
    const openBox = document.querySelector(".predictive-search-box.is-open");
    if (!openBox) return;
    // If click is inside search form or predictive box → ignore
    if (e.target.closest(".search-modal__form")) return;
    if (e.target.closest(".predictive-search-box")) return;
    const ctx = getSearchContext(openBox);
    closeSearch(ctx);
  });
})();

// for desktop search
document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector(".search-modal__form");
  if (!form) return;
  const input = form.querySelector('input[type="search"]');
  const recWrapper = form.querySelector(".predictive-search__rec-wrapper");
  if (!input || !recWrapper) return;
  input.addEventListener("keyup", function () {
    const hasValue = input.value.trim().length > 0;
    recWrapper.classList.toggle("is-hidden", hasValue);
  });
  const resetBtn = form.querySelector('button[type="reset"]');
  if (resetBtn) {
    resetBtn.addEventListener("click", () => {
      recWrapper.classList.remove("is-hidden");
    });
  }
});

// recent view product
  (function() {
    if (!window.location.pathname.includes('/products/')) return;

    // Get the product handle from the URL
    var handle = window.location.pathname.split('/products/')[1];

    // Read stored history
    var recent = JSON.parse(localStorage.getItem('recent_products') || "[]");

    // Remove if already exists
    recent = recent.filter(function(h) { return h !== handle; });

    // Add to front
    recent.unshift(handle);

    // Limit to 5 items
    if (recent.length > 5) recent.pop();

    // Save back
    localStorage.setItem('recent_products', JSON.stringify(recent));
  })();





// Header Localization Tabs (ADA)
document.querySelectorAll('.tab-btn').forEach((tab) => {
  tab.addEventListener('click', function () {
    const tabs = document.querySelectorAll('.tab-btn');
    const panels = document.querySelectorAll('.tab-content');

    tabs.forEach((btn) => {
      btn.classList.remove('active');
      btn.setAttribute('aria-selected', 'false');
      btn.setAttribute('tabindex', '-1');
    });

    panels.forEach((panel) => {
      panel.classList.remove('active');
      panel.hidden = true;
    });

    this.classList.add('active');
    this.setAttribute('aria-selected', 'true');
    this.setAttribute('tabindex', '0');

    const panel = document.getElementById(this.dataset.tab);

    if (panel) {
      panel.classList.add('active');
      panel.hidden = false;
    }

    this.focus();
  });

  // Keyboard support
  tab.addEventListener('keydown', function (e) {
    const tabs = [...document.querySelectorAll('.tab-btn')];
    const current = tabs.indexOf(this);

    let next = current;

    if (e.key === 'ArrowRight') {
      next = (current + 1) % tabs.length;
    }

    if (e.key === 'ArrowLeft') {
      next = (current - 1 + tabs.length) % tabs.length;
    }

    if (e.key === 'Home') {
      next = 0;
    }

    if (e.key === 'End') {
      next = tabs.length - 1;
    }

    if (next !== current) {
      e.preventDefault();
      tabs[next].click();
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {

  const toggle = document.querySelector(".localization-toggle");
  const drawer = document.getElementById("localization-drawer");
  const overlay = document.querySelector(".drawer-overlay");
  const drawerContent = document.querySelector(".drawer-content");

  if(!toggle || !drawer) return;

  function openDrawer(){
    drawer.classList.add("active");
    toggle.classList.add("open");
    document.body.classList.add("drawer-open");
  }

  function closeDrawer(){
    drawer.classList.remove("active");
    toggle.classList.remove("open");
    document.body.classList.remove("drawer-open");
  }

  toggle.addEventListener("click", function(e){
    e.stopPropagation();

    if(drawer.classList.contains("active")){
      closeDrawer();
    } else {
      openDrawer();
    }
  });

  if(overlay){
    overlay.addEventListener("click", closeDrawer);
  }

  document.addEventListener("click", function(e){

    if(
      drawer.classList.contains("active") &&
      !drawerContent.contains(e.target) &&
      !toggle.contains(e.target)
    ){
      closeDrawer();
    }

  });

  document.addEventListener("keydown", function(e){
    if(e.key === "Escape"){
      closeDrawer();
    }
  });

});

// mob
document.addEventListener("DOMContentLoaded", function () {

  const toggle = document.querySelector(".localization-toggle-mbl");
  const drawer = document.getElementById("loc-drawer");

  const overlay = drawer ? drawer.querySelector(".loc-drawer__overlay") : null;
  const content = drawer ? drawer.querySelector(".loc-drawer__content") : null;
  const closeBtn = drawer ? drawer.querySelector(".loc-drawer__close") : null;

  if (!toggle || !drawer) return;

  function openDrawer() {
    drawer.classList.add("active");
    toggle.classList.add("open");
    document.body.classList.add("drawer-open");
  }

  function closeDrawer() {
    drawer.classList.remove("active");
    toggle.classList.remove("open");
    document.body.classList.remove("drawer-open");
  }

  toggle.addEventListener("click", function (e) {
    e.stopPropagation();
    drawer.classList.contains("active") ? closeDrawer() : openDrawer();
  });

  if (overlay) overlay.addEventListener("click", closeDrawer);
  if (closeBtn) closeBtn.addEventListener("click", closeDrawer);

  document.addEventListener("click", function (e) {
    if (
      drawer.classList.contains("active") &&
      content &&
      !content.contains(e.target) &&
      !toggle.contains(e.target)
    ) {
      closeDrawer();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeDrawer();
  });

  /* Tabs */
  const tabs = drawer.querySelectorAll(".loc-drawer__tab-btn");
  const contents = drawer.querySelectorAll(".loc-drawer__tab-content");

  tabs.forEach(btn => {
    btn.addEventListener("click", function () {
      const target = btn.dataset.tab;

      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      btn.classList.add("active");

      const activeContent = drawer.querySelector(`#${target}`);
      if (activeContent) activeContent.classList.add("active");
    });
  });

});


// clear input on none 
document.addEventListener('change', function (e) {

  // NONE selected
  if (e.target.closest('.hide_fields')) {

    // clear visible fields
    [
      'ticketName',
      'ticketSection',
      'ticketRow',
      'ticketSeat'
    ].forEach(id => {
      const el = document.getElementById(id);

      if (el) {
        el.value = '';
        el.dispatchEvent(new Event('input', { bubbles: true }));
      }
    });

    // clear hidden fields
    [
      'get_ticketname',
      'get_ticketSection',
      'get_ticketRow',
      'get_ticketSeat'
    ].forEach(id => {
      const el = document.getElementById(id);
      if (el) el.value = '';
    });

  }

});
